/* unplugin-vue-components disabled */import script from "./user-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./user-item.vue?vue&type=script&lang=ts&setup=true"

import "./user-item.vue?vue&type=style&index=0&id=bbe9d768&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbe9d768"]])

export default __exports__